import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const INITIAL_STATE_LIST = {
  'loading': false,
  'list': [],
};

export const stockAdjustmentsList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_STOCK_ADJUSTMENTS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_STOCK_ADJUSTMENTS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_STOCK_ADJUSTMENTS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

export const stockAdjustmentsListDescription = (state, action) => {
  return createReducer(INITIAL_STATE_LIST, {
    [ActionTypes.FETCHING_DESCRIPTION_MANTAIN_SA_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_DESCRIPTION_MANTAIN_SA_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_DESCRIPTION_MANTAIN_SA_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};

